import { render, staticRenderFns } from "./Blok4a.vue?vue&type=template&id=f334ccde"
import script from "./Blok4a.vue?vue&type=script&lang=js"
export * from "./Blok4a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports